import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { resetPassword } from '../actions/authActions';

export default function ResetPassword() {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState({ kind: '', text: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setStatus({ kind: 'error', text: 'Passwords do not match.' }); return; }
    if (password.length < 8) { setStatus({ kind: 'error', text: 'Password must be at least 8 characters.' }); return; }
    setBusy(true);
    const res = await dispatch(resetPassword(token, password));
    setBusy(false);
    if (res.ok) {
      setStatus({ kind: 'success', text: 'Password reset. You are signed in.' });
      setTimeout(() => navigate('/dashboard'), 900);
    } else {
      setStatus({ kind: 'error', text: res.error });
    }
  };

  return (
    <section className="section narrow">
      <h1>Set a new password</h1>
      <form className="auth-form" onSubmit={submit}>
        <label>New password<input required type="password" minLength={8} value={password} onChange={e => setPassword(e.target.value)} /></label>
        <label>Confirm new password<input required type="password" value={confirm} onChange={e => setConfirm(e.target.value)} /></label>
        <button className="btn-primary" type="submit" disabled={busy}>{busy ? 'Saving…' : 'Set new password'}</button>
        {status.text && <p className={`status ${status.kind}`}>{status.text}</p>}
      </form>
    </section>
  );
}
